module.exports = {
  project1: {
    name: 'Adidas',
    image: 'adidas.jpg',
    desc: '<div><img src="http://kelleemartins.com/images/alphabounce1.jpg" alt="AlphaBounce Desktop View"><p>quick turn around<br>360</p><img src="http://kelleemartins.com/images/alphabounce2.jpg" alt="AlphaBounce Mobile View"></div>',
    havLink: false,
    link: '',
  },
  project2: {
    name: 'AWAL',
    image: 'awal.jpg',
    desc: '<div><p>When this project was first being discussed, I liked the design so much that I asked to be the lead on this project. I was really excited about this and finally getting the hang of a WordPress site from start to finish. As much as I love working with a group, it’s just so neat to know a project inside and out. This site became one of my babies and I learned SO much in the process of building it.</p><p>This design was actually done out of house and wasn’t as explicit in its functionality as I would have hoped for. Inferring what the client wanted, and deciding what was actually in scope of the original contract was probably my least favorite part of this job. I want to make a product that the client LOVES but I also want to make my project managers happy and stay within scope and budget.&nbsp;This is a constant industry battle, but this really showed to me how important it is to communicate often and clearly! Being an extrovert and coming into this industry I certainly didn’t anticipate that I would need to cultivate my communication skills, but they really take work and practice and it’s been a huge focus of mine.</p><p>The concept of the background images for this site was what initially intrigued me. They wanted the capability&nbsp;to upload a group of images and for the images to randomly shuffle behind a color filter that was determined by the content. I used CMB2 throughout the site. All of the content is completely customizable on the admin side. I also added Site Options which&nbsp;allow the user to upload a group of images that they want to be in the background. On page load, the images are pulled into a hidden div. Next,&nbsp;a random image is pulled and then used as the background image. Getting this to work, and to work quickly was one of my bigger struggles on this site. It also highlights my biggest mistake on the site. On my staging site I got my load time down and running super slick. But what I failed to do was put a limit on the photo sizes and force compression. On my staging site, all the images were optimized and compressed. Even though I instructed the user to compress their images and to not exceed a certain size, I didn’t enforce it in my code. Unfortunately, they ignored my instructions and the live site is super slow. I can’t even look at the live site without a face palm. But lesson learned, I’ll never again leave it up to the client to upload the correctly sized and compressed image.</p></div>',
    havLink: true,
    link: 'https://awal.com/',
  },
  project3: {
    name: 'BlueStar Cooking',
    image: 'bluestar.jpg',
    desc: '<div><p>I really enjoyed working on BlueStar! I was on the project from the very beginning which means I knew it inside out. That’s always an enjoyable experience, really makes you feel like you have a handle on things. I started off by building out the templates using HTML, CSS, PHP and JavaScript. Then I brought in CMB2 to handle the custom content and implemented custom post types to handle different products and gallery images. This is actually a pretty common flow in my projects. But each time I get faster, more modular, more thorough, and gain a more complete understanding of the tools and techniques I’m using.</p><img src="http://kelleemartins.com/images/bluestar1.jpg" alt="Bluestar Products Page"></div>',
    havLink: true,
    link: 'https://www.bluestarcooking.com/',
  },
  project4: {
    name: 'Boppy',
    image: 'boppy.jpg',
    desc: '<div><p>Boppy is actually a WordPress site but is using Nodus to handle the e-commerce. Getting these two to speak to each other required a lot of really creative development from my team. Most of my edits have been minor but my favorite was setting a cookie for the cart icon in the utility navigation. If something is added to the cart on the Nodus (ecomm) side than the product count in the cart will persist on the WordPress side.</p></div>',
    havLink: true,
    link: 'http://www.boppy.com/',
  },
  project5: {
    name: 'ClearChoice',
    image: 'clearchoice.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project6: {
    name: 'FjallRaven',
    image: 'fjallraven.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project7: {
    name: 'Voltage Ad - Playlists',
    image: 'voltageplaylist.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project8: {
    name: 'Hansen Orthodontics',
    image: 'hansen.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project9: {
    name: 'Pagosa Springs Medical Center',
    image: 'pagosasprings.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project10: {
    name: 'PlayerLync',
    image: 'playerlync.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project11: {
    name: 'Proctor Productions',
    image: 'proctor.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
  project12: {
    name: 'Reebok',
    image: 'reebok.jpg',
    desc: '',
    havLink: false,
    link: '',
  },
};



// WEBPACK FOOTER //
// ./src/myProjects.js